import React, {useEffect, useState} from 'react';
import { renderDropdown, renderDropdownReadOnly} from "../../gdpr/ui/DropdownFunctions";
import SpinnerDiv from "../../gdpr/ui/SpinnerDiv";
import PropTypes from "prop-types";
import {getResources} from "../../gdpr/ui/DropdownDataProviders";

const DropdownResources = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getResources(0, 'all').then (rows =>
        {
            //Add the All option to the top of dropdown
            const all = {label: 'All', value: 0}
            rows.unshift(all);
            setData ( { loading: false, items: rows }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownResources;

DropdownResources.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownResources.propTypes = {
    onChange: PropTypes.func.isRequired
};